// 相对时间格式化：不引 dayjs，纯本地实现。
// 传入 unix 秒（对齐 API DTO 的 receivedAt/readAt 等）。

export function formatRelative(unixSeconds: number, nowMs: number = Date.now()): string {
  const then = unixSeconds * 1000;
  const diff = Math.floor((nowMs - then) / 1000); // 秒差
  if (diff < 0) return '刚刚';
  if (diff < 60) return '刚刚';
  if (diff < 3600) return `${Math.floor(diff / 60)} 分钟前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} 小时前`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} 天前`;

  // 超过 7 天：显示日期
  const d = new Date(then);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const thisYear = new Date(nowMs).getFullYear();
  if (d.getFullYear() === thisYear) return `${mm}-${dd}`;
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function formatDateTime(unixSeconds: number): string {
  const d = new Date(unixSeconds * 1000);
  const y = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${mm}-${dd} ${hh}:${mi}`;
}
